// APIs

export const LOGIN = "/auth/token/";
export const GET_TODOS = "/api/features/todo/";
export const MY_PROFILE = "/api/myprofile/";
export const UPDATE_USER_PROFILE = "/api/user/profile/";
export const USER_BIO = "api/myprofilebio/";
export const NOTIFICATION = "/api/notification/user/";
export const NOTIFICATION_STATUS = "/api/notification/read/";
export const FEEDBACK = "/api/features/feedback/";
export const GET_QUIZ = "/api/features/quiz/questions/";
export const SUBMIT_QUIZ = "/api/features/quiz/question-answers";
export const AVAILABLE_SURVEY = "/api/features/survey/available";
export const COMPLETED_SURVEY = "/api/features/survey/completed";
export const ANSWER_SURVEY = "/api/features/survey/answer";
export const TICKET_CLIENT = "/api/features/ticket/clientuser";
export const NEW_TICKET = "/api/features/ticket/";
export const TICKET_RESPONSE = "/api/features/ticket/response";
export const ANNOUNCEMENT = "api/notification/user/";
export const PODCAST = "/api/client/podcast/?media-type=PODCAST";
export const PODCAST_ALL = "/api/client/podcast/";
export const GET_INHOUSE = "/api/client/inhouse/?media-type=INHOUSE";

export const GET_CHATS = "/api/features/chat/chat";
export const ADD_MESSAGE = "/api/features/chat/";

export const IDEA_BOARD = "/api/features/ideaboard/";
export const IDEA_BOARD_DOWNLOAD = "/api/features/ideaboard/export-feature-ideas/csv/"
export const IDEA_BOARD_RESPONSE = "/api/features/ideaboard/response";
export const HOF = "/api/features/halloffame/";
export const HOF_RESPONSE = "/api/features/halloffame/response";
export const ANNOUNCEMENTS = "/api/features/announcement/";
export const ANNOUNCEMENT_RESPONSE = "/api/features/announcement/response";

export const DISCUSSION_BOARD = "/api/features/discussionboard/";
export const ADD_RESPONSE = "api/features/discussionboard/response";
export const E_MAGAZINE = "api/features/emagazine/user/";
export const VIRTUAL_EVENT = "api/features/virtualevent/user/";
export const SOS = "/api/features/sos/user/";

//Media

export const INHOUSE_LIST = "/api/client/inhouse/";
export const ADD_TO_FAV = "/api/client/select/inhouse/";
export const REMOVE_FROM_FAV = "/api/client/unselect/inhouse/";
export const GET_INHOUSE_FAV_LIST =
  "/api/client/selected/inhouse/?selected-type=FAVOURITE";
export const GET_INHOUSE_PLAYLIST =
  "/api/client/selected/inhouse/?selected-type=PLAYLIST";
export const GET_PODCAST_FAV_LIST =
  "/api/client/selected/podcast/?selected-type=FAVOURITE";
export const GET_PODCAST_PLAYLIST =
  "/api/client/selected/podcast/?selected-type=PLAYLIST";
export const TRENDING_PODCASTS = "/api/client/trending";
export const MOST_VIEWED_PODCASTS = "/api/client/viewed/podcast";

export const PODCAST_LIST = "/api/client/podcast/";
export const ADD_TO_FAV_PODCAST = "/api/client/select/podcast/";
export const REMOVE_FROM_FAV_PODCAST = "/api/client/unselect/podcast/";
export const TAG_SEARCH = "/api/client/inhouse/tagsearch";
export const SEARCH_RESULTS = "/api/client/globalSearch";

// export const ADD_MESSAGE = "/api/features/chat"

// export const GET_FAQ = "/api/features/faq/";
export const GET_FAQ = "/api/features/faq/list-faq/";

// Company Admin Panel
export const DASHBOARD = "/api/client/dashboard/";
export const GET_EMPLOYEES = "/api/client/user/";
export const ADD_EMPLOYEES = "/api/user/";
export const EMPLOYEE_STATUS = "/api/client/user/";
export const PODCAST_UNIT = "/api/podcast/unit/";
export const INHOUSE_CHANNEL = "/api/inhouse/superunit/";
export const INHOUSE_EPISODE = "/api/inhouse/unit/";
export const FILE_UPLOAD_PRIVATE = "/api/common/file/private/";
export const PODCAST_CHANNEL = "/api/podcast/channel/";
export const INHOUSE_CHANNEL_LIST = "/api/inhouse/channel/";
export const FEATURE_LIST = "/api/client/feature/";
export const FEATURE_USER_LIST = "api/client/user-feature/";
export const ALL_SURVEY = "/api/features/survey/user";
export const ADD_SURVEY = "/api/features/survey/";
export const ADD_MEETING = "/api/features/meeting/";
export const FEATURE_ADMIN = "/api/client/feature-admin/";
export const MAGAZINE = "/api/features/magazine/client";
export const MAGAZINE_STATUS = "/api/features/magazine/client/";
export const EMAGAZINE = "/api/features/emagazine/";
export const IDEABOARD = "/api/features/ideaboard/";
export const TICKET_ADMIN = "/api/features/ticket/client";
export const HALLOFFAME = "/api/features/halloffame/";
export const ANNOUNCEMENT_ADMIN = "/api/features/announcement/";
export const SOS_ADMIN = "/api/features/sos/";
export const VIRTUAL_EVENT_ADMIN = "api/features/virtualevent/";
export const EMPLOYEE_DOWNLOAD = "/api/client/export-employees-list/";
export const SURVEY_SPECIAL_DOWNLOAD = "/api/features/survey/list/participant/";
export const SURVEY_NON_PARTICIPANT = "/api/features/survey/list/non-participant/"

//Super Admin Panel

export const GET_CLIENT_LIST = "/api/client/";
export const UPLOAD_LOGO = "/api/common/file/private/";
export const GET_PODCAST = "/api/podcast/unit/";
export const UPLOAD_INHOUSE = "/api/inhouse/unit/";
export const GET_GROUP = "/api/client/group/";
export const GET_COUNTRY = "/api/client/country/";
export const GET_SECTOR = "/api/client/sector/";
export const GET_THUB = "/api/feature/";
export const CREATE_CHANNEL = "/api/inhouse/superunit/";
export const PODCAST_CHANNELS = "/api/podcast/superunit/";
export const CHANNEL = "/api/client/channel/";
export const CLIENT_CHANNELS = "/api/client/client-channels/";
export const PODCAST_SCHEDULE = "api/podcast/schedule/"
// // APIs

// export const LOGIN = "/auth/token/";
// export const GET_TODOS = "/api/features/todo/";
// export const MY_PROFILE = "/api/myprofile/";
// export const UPDATE_USER_PROFILE = "/api/user/profile/";
// export const USER_BIO = "api/myprofilebio/";
// export const NOTIFICATION = "/api/notification/user/";
// export const FEEDBACK = "/api/features/feedback/";
// export const GET_QUIZ = "/api/features/quiz/questions/";
// export const SUBMIT_QUIZ = "/api/features/quiz/question-answers";
// export const AVAILABLE_SURVEY = "/api/features/survey/available";
// export const COMPLETED_SURVEY = "/api/features/survey/completed";
// export const ANSWER_SURVEY = "/api/features/survey/answer";

// export const NEW_TICKET = "/api/features/ticket/";
// export const ANNOUNCEMENT = "api/notification/user/";
// export const PODCAST = "/api/client/podcast/?media-type=PODCAST";
// export const PODCAST_ALL = "/api/client/podcast/";
// export const GET_INHOUSE = "/api/client/inhouse/?media-type=INHOUSE";

// export const GET_CHATS = "/api/features/chat/chat";
// export const ADD_MESSAGE = "/api/features/chat";

// export const DISCUSSION_BOARD = "/api/features/discussionboard/";
// export const ADD_RESPONSE = "api/features/discussionboard/response";
// export const E_MAGAZINE = "api/features/magazine/client";

// //Media

// export const INHOUSE_LIST = "/api/client/inhouse/";
// export const ADD_TO_FAV = "/api/client/select/inhouse/";
// export const REMOVE_FROM_FAV = "/api/client/unselect/inhouse/";
// export const GET_INHOUSE_FAV_LIST =
//   "/api/client/selected/inhouse/?selected-type=FAVOURITE";
// export const GET_INHOUSE_PLAYLIST =
//   "/api/client/selected/inhouse/?selected-type=PLAYLIST";
// export const GET_PODCAST_FAV_LIST =
//   "/api/client/selected/podcast/?selected-type=FAVOURITE";
// export const GET_PODCAST_PLAYLIST =
//   "/api/client/selected/podcast/?selected-type=PLAYLIST";
// export const TRENDING_PODCASTS = "/api/client/trending";
// export const MOST_VIEWED_PODCASTS = "/api/client/viewed/podcast";

// export const PODCAST_LIST = "/api/client/podcast/";
// export const ADD_TO_FAV_PODCAST = "/api/client/select/podcast/";
// export const REMOVE_FROM_FAV_PODCAST = "/api/client/unselect/podcast/";

// // export const ADD_MESSAGE = "/api/features/chat"

// export const GET_FAQ = "/api/features/faq/";

// // Company Admin Panel

// export const GET_EMPLOYEES = "/api/client/user/";
// export const ADD_EMPLOYEES = "/api/user/";
// export const EMPLOYEE_STATUS = "/api/client/user/";
// export const PODCAST_UNIT = "/api/podcast/unit/";
// export const INHOUSE_CHANNEL = "/api/inhouse/superunit/";
// export const INHOUSE_EPISODE = "/api/inhouse/unit/";
// export const FILE_UPLOAD_PRIVATE = "/api/common/file/private/";
// export const PODCAST_CHANNEL = "/api/podcast/channel/";
// export const INHOUSE_CHANNEL_LIST = "/api/inhouse/channel/";

// //Super Admin Panel

// export const GET_CLIENT_LIST = "/api/client/";
